/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable no-eval */
import { isClient } from 'constants/app';
import { ORDER_TYPE, STOCK_TYPE } from 'constants/trading';
import { lotSize } from 'global/TradingModal/constant';

export const calculateLotAmendTransaction = (
  previous_buy_price,
  previous_lot,
  price,
  lot,
) => {
  // Prevent user increase lot with previous trade price
  // updating to use calculation procedure based on legacy
  // https://gitlab.com/stockbitgroup/stockbit/web/web/-/blob/staging/app/routes/securities/component/trade/ModalBuy.js#L351
  if (price === previous_buy_price && lot > previous_lot) {
    return previous_lot;
  }
  return lot;
};

const calculateInitialTradingBalance = (
  stock_type,
  order_type,
  cash_on_hand,
  trading_balance,
  cash_onhand_amended,
  trading_balance_amended,
  isDayTrade = false,
) => {
  if (stock_type.toLowerCase() === STOCK_TYPE.right) {
    return order_type === ORDER_TYPE.AMEND_BUY
      ? cash_onhand_amended
      : cash_on_hand;
  }

  if (order_type === ORDER_TYPE.AMEND_BUY && isDayTrade) {
    return trading_balance;
  }

  return order_type === ORDER_TYPE.AMEND_BUY
    ? trading_balance_amended
    : trading_balance;
};

// eslint-disable-next-line import/prefer-default-export
export const generateTradingVariable = ({
  configFormula,
  cash_on_hand,
  trading_balance,
  price,
  lot,
  trigger_price,
  config_type,
  order_type,
  previous_buy_price,
  previous_lot,
  stock_type,
  trading_balance_amended,
  cash_onhand_amended,
  isDayTrade = false,
}) => {
  if (isClient()) {
    const {
      formula: {
        fee_buy,
        fee_buy_day_trade,
        buy_amount_invested,
        buy_amount_invested_fee,
        buy_amount_fee,
        buy_amount_broker_fee,
        buy_amount_exchange_fee,
      },
      preview_fee,
      day_trade,
    } = configFormula;

    const { broker_fee, exchange } = isDayTrade
      ? day_trade?.preview_fee
      : preview_fee;

    const PRICE = Number(price);
    let LOT = Math.round(Number(lot));
    const TRIGGER_PRICE = Number(trigger_price);
    const CONFIG_TYPE = Number(config_type);

    if (order_type === ORDER_TYPE.AMEND_BUY) {
      LOT = calculateLotAmendTransaction(
        previous_buy_price,
        previous_lot,
        PRICE,
        LOT,
      );
    }

    const FEE_BUY = isDayTrade ? Number(fee_buy_day_trade) : Number(fee_buy);
    const BROKER_FEE = Number(broker_fee);
    const EXCHANGE_FEE_TOTAL_BUY = Number(exchange.exchange_fee_total_buy);

    // if the source of eval script comes from controlled env (e.g. backend),
    // its relatively safe to use eval (https://stackoverflow.com/a/23175542)
    // so I add nosemgrep, to surprass nosemgrep
    const BUY_AMOUNT = eval(buy_amount_invested); // nosemgrep
    const BUY_AMOUNT_FEE = eval(buy_amount_invested_fee); // nosemgrep
    const BUY_FEE = eval(buy_amount_fee); // nosemgrep
    const STOCKBIT_FEE = eval(buy_amount_broker_fee); // nosemgrep
    const EXCHANGE_FEE = eval(buy_amount_exchange_fee); // nosemgrep

    const TRADING_BALANCE = calculateInitialTradingBalance(
      stock_type,
      order_type,
      cash_on_hand,
      trading_balance,
      cash_onhand_amended,
      trading_balance_amended,
      isDayTrade,
    );

    const BUY_PRICE_WITH_FEE = (PRICE * FEE_BUY + PRICE) * lotSize;
    const LIMIT_LOT = Math.floor(TRADING_BALANCE / BUY_PRICE_WITH_FEE);

    return {
      TRADING_BALANCE,
      BUY_AMOUNT_FEE,
      BUY_AMOUNT,
      PRICE,
      BUY_FEE,
      STOCKBIT_FEE,
      EXCHANGE_FEE,
      LOT,
      LIMIT_LOT,
      TRIGGER_PRICE,
      CONFIG_TYPE,
    };
  }
  return null;
};

// eslint-disable-next-line import/prefer-default-export
export const getInvestmentFee = ({ configFormula, price, lot }) => {
  if (isClient()) {
    const {
      formula: { fee_buy, buy_amount_invested_fee },
    } = configFormula;

    const PRICE = Number(price);
    const LOT = Math.round(Number(lot));

    const FEE_BUY = Number(fee_buy);

    // if the source of eval script comes from controlled env (e.g. backend),
    // its relatively safe to use eval (https://stackoverflow.com/a/23175542)
    // so I add nosemgrep, to surprass nosemgrep
    const BUY_AMOUNT_FEE = eval(buy_amount_invested_fee); // nosemgrep

    return BUY_AMOUNT_FEE;
  }
  return 0;
};

export const checkIsAutoOrderTncAgreed = (
  userName: string,
  autoOrderType: string,
): boolean => {
  const logTnc = JSON.parse(localStorage.getItem('logTnc'));
  if (!logTnc) return false;

  const usernameFound = logTnc.find(
    (item) => item.username === userName && item.product === autoOrderType,
  );
  if (usernameFound) return true;
  return false;
};
